import React, { useState } from 'react';
import { screensService } from '../services/api';

function SendToScreensModal({ page, screens, onClose, onSuccess }) {
  const [selected, setSelected] = useState([]);
  const [duration, setDuration] = useState('permanent');
  const [loading, setLoading] = useState(false);

  const toggle = (id) => {
    setSelected(s => s.includes(id) ? s.filter(x => x !== id) : [...s, id]);
  };

  const toggleAll = () => {
    if (selected.length === screens.length) setSelected([]);
    else setSelected(screens.map(s => s.id));
  };

  const handleSend = async () => {
    if (selected.length === 0) return;
    setLoading(true);
    try {
      await screensService.setOverride({
        screen_ids: selected,
        page_id: page.id,
        duration: duration
      });
      onSuccess && onSuccess(selected.length);
      onClose();
    } catch (e) {
      alert('Erreur: ' + (e.response?.data?.error || 'envoi impossible'));
    } finally {
      setLoading(false);
    }
  };

  const durations = [
    { value: '30min', label: '30 minutes' },
    { value: '1h', label: '1 heure' },
    { value: '4h', label: '4 heures' },
    { value: 'midnight', label: "Jusqu'a minuit" },
    { value: 'permanent', label: "Jusqu'a annulation" }
  ];

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()} style={{maxWidth: '520px'}}>
        <div className="modal-header">
          <h2>Envoyer "{page.name}"</h2>
          <button onClick={onClose} className="close-btn">x</button>
        </div>

        <div className="modal-body">
          <div style={{marginBottom: '20px'}}>
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px'}}>
              <label style={{fontWeight: 600}}>Ecrans cibles</label>
              <button type="button" onClick={toggleAll} className="btn-sm" style={{fontSize: '0.75rem'}}>
                {selected.length === screens.length ? 'Tout deselectionner' : 'Tout selectionner'}
              </button>
            </div>
            <div style={{display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '8px', maxHeight: '240px', overflowY: 'auto', padding: '8px', background: 'var(--bg-2)', borderRadius: '6px'}}>
              {screens.length === 0 && (
                <div style={{opacity: 0.6, gridColumn: '1 / -1', textAlign: 'center', padding: '12px'}}>Aucun ecran</div>
              )}
              {screens.map(s => (
                <label key={s.id} style={{display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', padding: '6px', borderRadius: '4px', background: selected.includes(s.id) ? 'var(--accent-dim, rgba(100,150,255,0.15))' : 'transparent'}}>
                  <input
                    type="checkbox"
                    checked={selected.includes(s.id)}
                    onChange={() => toggle(s.id)}
                  />
                  <span style={{display: 'flex', alignItems: 'center', gap: '6px'}}>
                    <span className={`status-dot ${s.is_online ? 'online' : 'offline'}`} style={{width: '8px', height: '8px'}}></span>
                    {s.name}
                  </span>
                </label>
              ))}
            </div>
          </div>

          <div style={{marginBottom: '16px'}}>
            <label style={{fontWeight: 600, display: 'block', marginBottom: '8px'}}>Duree</label>
            <div style={{display: 'flex', flexDirection: 'column', gap: '6px'}}>
              {durations.map(d => (
                <label key={d.value} style={{display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer'}}>
                  <input
                    type="radio"
                    name="duration"
                    value={d.value}
                    checked={duration === d.value}
                    onChange={e => setDuration(e.target.value)}
                  />
                  <span>{d.label}</span>
                </label>
              ))}
            </div>
          </div>

          <div style={{padding: '10px', background: 'rgba(255,200,100,0.1)', border: '1px solid rgba(255,200,100,0.3)', borderRadius: '4px', fontSize: '0.85rem', marginBottom: '12px'}}>
            Cette page remplacera le planning horaire sur les ecrans selectionnes.
          </div>
        </div>

        <div className="modal-footer">
          <button onClick={onClose} className="btn-secondary">Annuler</button>
          <button
            onClick={handleSend}
            className="btn-primary"
            disabled={selected.length === 0 || loading}
          >
            {loading ? 'Envoi...' : `Envoyer (${selected.length})`}
          </button>
        </div>
      </div>
    </div>
  );
}

export default SendToScreensModal;
